import { useState } from "react";
import { apiWithoutCamelization } from "../../../api";
import { useToast } from "../../../mantine/notifications/useToast";
import urls from "../../../urls";
import { pollTaskStatus } from "../../../utils/api-utils";
import { downloadPDF } from "../../../utils/downloadPdf";
import type { PendingInvoice } from "./usePendingInvoices";

interface GenerateAndDownloadPreviewParams {
  pendingInvoice: PendingInvoice;
}

function usePreviewInvoices() {
  const { showErrorToast } = useToast();
  const [loadingPreviews, setLoadingPreviews] = useState<Array<string>>([]);

  function removeLoadingId(id: string) {
    setLoadingPreviews((prev) => prev.filter((loadId) => loadId !== id));
  }

  function getPDFfromBackend({
    contractId,
    taskId,
    draftId
  }: {
    contractId: string;
    taskId: string;
    draftId: string;
  }) {
    apiWithoutCamelization
      .get(urls.api.getPreviewInvoice(contractId, taskId))
      .then((r) => {
        downloadPDF(r);
      })
      .catch((error) => {
        showErrorToast(error);
      })
      .finally(() => {
        removeLoadingId(draftId);
      });
  }

  async function generateAndDownloadPreview({
    pendingInvoice
  }: GenerateAndDownloadPreviewParams) {
    const contractId = pendingInvoice.contract;
    if (!contractId) return;

    const draftId = pendingInvoice.id;
    setLoadingPreviews((prev) => [...prev, draftId]);

    return apiWithoutCamelization
      .post(urls.api.generatePreviewInvoices(), pendingInvoice)
      .then((response) => {
        if (response.data) {
          pollTaskStatus(
            urls.api.jobStatus(response.data.task_ids[0]),
            () =>
              getPDFfromBackend({
                contractId,
                taskId: response.data.task_ids[0],
                draftId
              }),
            (error) => {
              removeLoadingId(draftId);
              showErrorToast(error);
            }
          );
        }
      });
  }

  return { generateAndDownloadPreview, loadingPreviews };
}

export { usePreviewInvoices, GenerateAndDownloadPreviewParams };
